import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import {
	KLEARAI_LOGO_URL,
	LOGIN_LOGO_URL,
} from "src/app/shared/constant/constant";
import { SnackBarService } from "src/app/shared/service/snack-bar/snack-bar.service";
import { SubSink } from "subsink";
import { AuthService } from "../../service/auth/auth.service";

@Component({
	selector: "app-login",
	templateUrl: "./login.component.html",
	styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
	private subs = new SubSink();
	loggingIn: boolean = false;
	loginForm: UntypedFormGroup;
	userDetails: any = {
		username: "",
		password: "",
		// clientName: "adminsure",
		// productName: "klear-claims",
	};
	url: string;
	forgotUrl: any;
	klearAiLogoUrl: string = KLEARAI_LOGO_URL;
	loginLogoUrl: string = LOGIN_LOGO_URL;

	constructor(
		private router: Router,
    private authService: AuthService,
    private snackBarService: SnackBarService
	) {}

	ngOnInit(): void {
		if (this.authService.isLoggedIn)
			//this.router.navigate(['/home']);
			this.router.navigate(["/home/my-claims"]);
	}


  //deprecated (Use appService)
	getForgotURL(): string {
		return JSON.parse(localStorage.getItem("layoutConfig")).urls.FORGOT_URL;
  }

  validateUserCreds(): boolean {
    if (
			this.userDetails.username.trim() == "" &&
			this.userDetails.password.trim() == ""
		) {
			this.snackBarService.openSnackBar(
				"Please enter Username and Password to login",
				"",
				5000
      );
      return false;
    }
    if (this.userDetails.username.trim() == "") {
      this.snackBarService.openSnackBar("Please enter Username", "", 5000);
      return false;
    }
    if (this.userDetails.password.trim() == "") {
      this.snackBarService.openSnackBar("Please enter Password", "", 5000);
      return false;
    }
    return true;
  }

	login() {
    if (!this.validateUserCreds()) {
      return;
    }
    const {username, password} = this.userDetails;
    const data = {
      username: username,
      password: password
    }
    this.subs.sink = this.authService.getToken(JSON.stringify(data)).subscribe(
      (res: boolean | string) => {
        if (res === true) {
          const loginData = {
            username: username
          }
          this.authService.loginUser(JSON.stringify(loginData)).subscribe({
            next: (res: boolean) => {
              if (res === true) {
                localStorage.setItem("lobId", "0");
                this.router.navigate(['/home/my-claims'])
              } else {
                this.snackBarService.openSnackBar("Error in logging in", "", 5000);
                throw new Error(res + '')
              }
              this.loggingIn = false
            },
            error: (err) => {
              this.snackBarService.openSnackBar("Error in logging in", "", 5000);
              this.loggingIn = false
              throw new Error(err.message)
            },
          });
        } else {
          this.snackBarService.openSnackBar("Error in logging in", "", 5000);
          this.loggingIn = false
          throw new Error(res.toString());
        }
      },
      (err) => {
        this.snackBarService.openSnackBar("Error in getting token", "", 5000);
        this.loggingIn = false
        throw new Error(err.message)
      },
    );
    this.loggingIn = true;
	}

	forgotPassword() {
		this.url = this.getForgotURL();
		window.open(this.url);
	}

	ngOnDestroy() {
		this.subs.unsubscribe();
	}
}
